// src/firebase.js

import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// Firebase configuration.
//
// IMPORTANT: the hardcoded values below are the REAL public config for the
// `ordering-dashboard-solut-114ef` project and are the single source of truth.
// They MUST stay in sync with public/firebase-messaging-sw.js (the service
// worker uses the same values). Push notifications break completely without a
// valid messagingSenderId / projectId / appId: getToken() fails, no device
// token is registered, and the backend has no one to push to.
//
// The hardcoded values are used as a FALLBACK so push works with NO .env at all
// (local AND staging). If proper VITE_FIREBASE_* env vars are provided they take
// precedence. (Firebase web config is not secret — it is shipped to the client.)
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyBPhA3Cc4aGtZnjWUbyPWVzCBx0JW91G3U",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "ordering-dashboard-solut-114ef.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "ordering-dashboard-solut-114ef",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "ordering-dashboard-solut-114ef.appspot.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "86346681920",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:86346681920:web:b0f83004f654ed8f97d9a5",
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// getMessaging() checks browser support asynchronously and, when it is missing,
// throws "messaging/unsupported-browser" from a promise nobody can catch — an
// unhandled rejection on every page load in iOS Safari outside the home-screen
// app (no PushManager). Run the synchronous part of Firebase's own check first
// and leave `messaging` undefined there; every caller already handles that.
const browserSupportsMessaging = () =>
  typeof window !== "undefined" &&
  "indexedDB" in window &&
  navigator.cookieEnabled &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window &&
  "fetch" in window &&
  typeof ServiceWorkerRegistration !== "undefined" &&
  ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification") &&
  typeof PushSubscription !== "undefined" &&
  PushSubscription.prototype.hasOwnProperty("getKey");

// Initialize Messaging only in a browser that supports it
let messaging;
if (browserSupportsMessaging()) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.error("Firebase Messaging initialization error:", error);
  }
}

export { app, messaging };
